import ManageInvites from "./ManageInvites";

import "./Index.scss";

const Invites = () => (
  <div className="preferencesInvites">
    <ManageInvites />
  </div>
);

export default Invites;
